import { combineReducers } from 'redux';
import valueReducer from '../../../common/reducers/valueReducer';
import {
  SET_BARBER_FILTER,
  SET_METRICS,
  SET_DIRTY,
  RESET_DIRTY,
} from './constants';
import barberFilter from '../../../common/reducers/barberFilter';
import * as types from '../constants';
import {
  CHANGE_SHOP,
  RESET_SHOP,
} from '../../../auth/constants';
import { SET as SET_LEADERBOARD } from '../dash/constants';
import {
  SHOP_FILTER_DESELECT_ALL,
  SHOP_FILTER_SELECT_ALL,
  UPDATE_SHOP_FILTER,
} from '../filters/ShopFilter/constants';

const data = valueReducer({}, SET_METRICS, [CHANGE_SHOP, RESET_SHOP]);

const isDirty = (state = false, action) => {
  switch (action.type) {
    case types.ADD_BARBER_FILTER_REPORT:
    case types.REMOVE_BARBER_FILTER_REPORT:
    case types.SHOW_ALL_BARBER_FILTERS_REPORT:
    case types.HIDE_ALL_BARBER_FILTERS_REPORT:
    case types.SET_REPORTS_START_DATE:
    case types.SET_REPORTS_END_DATE:
    case types.UPDATE_CATEGORY_FILTER:
    case types.UPDATE_BRAND_FILTER:
    case types.CATEGORY_FILTER_DESELECT_ALL:
    case types.CATEGORY_FILTER_SELECT_ALL:
    case types.UPDATE_BRAND_FILTER_DESELECT_ALL:
    case types.UPDATE_BRAND_FILTER_SELECT_ALL:
    case UPDATE_SHOP_FILTER:
    case SET_DIRTY:
    case SHOP_FILTER_SELECT_ALL:
    case SHOP_FILTER_DESELECT_ALL:
      return true;
    case SET_METRICS:
    case RESET_DIRTY:
    case SET_LEADERBOARD:
      return false;
    default:
      return state;
  }
};

const hasDateChanged = (state = false, action) => {
  switch (action.type) {
    case types.SET_REPORTS_START_DATE:
    case types.SET_REPORTS_END_DATE:
      return true;
    case SET_METRICS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  data,
  barberFilter: barberFilter({
    add: types.ADD_BARBER_FILTER_REPORT,
    remove: types.REMOVE_BARBER_FILTER_REPORT,
    show: types.SHOW_ALL_BARBER_FILTERS_REPORT,
    hide: types.HIDE_ALL_BARBER_FILTERS_REPORT,
    set: SET_BARBER_FILTER,
  }),
  isDirty,
  hasDateChanged,
});
